import { TranslocoService } from '@jsverse/transloco';
import { fromLocalized, isLocalizedString, LocalizedString } from '@cue/api';

export function localized(
  str: LocalizedString | string,
  translocoService: TranslocoService,
  fallbackToDefault: boolean = true
): string {
  if (isLocalizedString(str)) {
    return fromLocalized(str, translocoService.getActiveLang(), translocoService.getDefaultLang(), fallbackToDefault);
  }
  return str;
}
